<button valgButton ngClass="tip-button" (click)="openDialog()" *ngIf="data">
  <span [class.sr-only]="!showText">{{ 'tip.button' | translate }}</span>
  <mat-icon [svgIcon]="SvgIcon.Info"></mat-icon>
</button>